import ServiceReports from '../../../../../services/ServiceReports';

class Service extends ServiceReports {
  constructor() {
    super('/callcenter/in');
  }
}

export default new Service();
